// extracted by mini-css-extract-plugin
module.exports = {"AwesomeRwdMenu":"AwesomeRwdMenu_AwesomeRwdMenu__2Ejey"};